import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import TrialStart from "@/pages/TrialStart";
import Rewards from "@/pages/Rewards";
import ProtectedRoute from "@/components/ProtectedRoute";
import ParentGate from "@/components/ParentGate";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import ParentDashboard from "@/pages/ParentDashboard";
import ChildProgress from "@/pages/ChildProgress";
import ReviewQuestions from "@/pages/ReviewQuestions";
import HolidayPackAdmin from "@/pages/HolidayPackAdmin";
import ManageVideos from "@/pages/ManageVideos";
import KidHome from "@/pages/KidHome";
import AvatarCollection from "@/pages/AvatarCollection";
import SubjectView from "@/pages/SubjectView";
import QuizPlayer from "@/pages/QuizPlayer";
import MathPad from "@/pages/MathPad";
import AdminPage from "@/pages/AdminPage";
import Survey from "@/pages/Survey";
import AccessEnded from "@/pages/AccessEnded";
import ResetPin from "@/pages/ResetPin";
import MyInvoices from "@/pages/MyInvoices";
import SetPassword from "@/pages/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import HolidayPlayer from "@/pages/HolidayPlayer";
import FrVoiceHelp from "@/components/FrVoiceHelp";
import ContentGuard from "@/components/ContentGuard";
import ReadingHome from "@/pages/ReadingHome";
import ReadingPath from "@/pages/ReadingPath";
import ReadingLesson from "@/pages/ReadingLesson";
import ReadingDiagnostic from "@/pages/ReadingDiagnostic";
import ReadingStory from "@/pages/ReadingStory";
import ReadingCertificate from "@/pages/ReadingCertificate";
import ReadingFrequent from "@/pages/ReadingFrequent";
import ReadingSurvey from "@/pages/ReadingSurvey";
import ReadingText from "@/pages/ReadingText";
import ReadingApp from "@/pages/ReadingApp";
import ParentTestPapers from "@/pages/ParentTestPapers";
import TestPaperPlayer from "@/pages/TestPaperPlayer";
import ReadingAppGuard from "@/components/ReadingAppGuard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/lecture" element={<ReadingApp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/access-ended" element={<AccessEnded />} />
            <Route path="/reset-pin" element={<ResetPin />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/parent" element={<ProtectedRoute><ParentGate><ParentDashboard /></ParentGate></ProtectedRoute>} />
            <Route path="/parent/invoices" element={<ProtectedRoute><ParentGate><MyInvoices /></ParentGate></ProtectedRoute>} />
            <Route path="/parent/test-papers" element={<ProtectedRoute><ParentGate><ParentTestPapers /></ParentGate></ProtectedRoute>} />
            <Route path="/kid/:childId/test/:paperId" element={<ProtectedRoute kid><TestPaperPlayer /></ProtectedRoute>} />
            <Route path="/parent/child/:childId" element={<ProtectedRoute><ParentGate><ChildProgress /></ParentGate></ProtectedRoute>} />
            <Route path="/admin/review" element={<ProtectedRoute adminOnly><ReviewQuestions /></ProtectedRoute>} />
            <Route path="/admin/holiday-pack" element={<ProtectedRoute adminOnly><HolidayPackAdmin /></ProtectedRoute>} />
            <Route path="/admin/videos" element={<ProtectedRoute adminOnly><ManageVideos /></ProtectedRoute>} />
            <Route path="/kid/:childId" element={<ProtectedRoute kid><KidHome /></ProtectedRoute>} />
            <Route path="/kid/:childId/collection" element={<ProtectedRoute kid><AvatarCollection /></ProtectedRoute>} />
            <Route path="/kid/:childId/subject/:subject" element={<ProtectedRoute kid><SubjectView /></ProtectedRoute>} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/kid/:childId/demo" element={<ProtectedRoute kid><TrialStart kid /></ProtectedRoute>} />
            <Route path="/parent/trial/:childId" element={<ProtectedRoute><ParentGate><TrialStart /></ParentGate></ProtectedRoute>} />
            <Route path="/kid/:childId/holiday" element={<ProtectedRoute kid><HolidayPlayer /></ProtectedRoute>} />
            <Route path="/kid/:childId/play" element={<ProtectedRoute kid><QuizPlayer /></ProtectedRoute>} />
            <Route path="/kid/:childId/pad" element={<ProtectedRoute kid><MathPad /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading" element={<ProtectedRoute kid><ReadingHome /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/lesson/:lessonId" element={<ProtectedRoute kid><ReadingLesson /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/story/:storyId" element={<ProtectedRoute kid><ReadingStory /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/text/:textId" element={<ProtectedRoute kid><ReadingText /></ProtectedRoute>} />
            <Route path="/reading-certificate/:childId/:lang/:level" element={<ProtectedRoute><ReadingCertificate /></ProtectedRoute>} />
            <Route path="/reading-survey" element={<ProtectedRoute><ReadingSurvey /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/:lang/test" element={<ProtectedRoute kid><ReadingDiagnostic /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/:lang" element={<ProtectedRoute kid><ReadingPath /></ProtectedRoute>} />
            <Route path="/kid/:childId/reading/frequent/:lang" element={<ProtectedRoute kid><ReadingFrequent /></ProtectedRoute>} />
          </Routes>
          <ContentGuard />
          <ReadingAppGuard />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <FrVoiceHelp />
      </AuthProvider>
    </div>
  );
}

export default App;
